import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.softblue.css";
// import "./themes/generated/theme.base.css";
// import "./themes/generated/theme.additional.css";
import "./themes/generated/dx.generic.custom.css";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import appInfo from "./app-info";
import VueSimpleAlert from "vue-simple-alert";
import UserLib from "@/utils/UserLib.js";
import includeHTML from "./assets/lib/js/includeHTML";
import common from "./assets/lib/js/common";
import "devextreme/localization/globalize/number";
import "devextreme/localization/globalize/date";
import "devextreme/localization/globalize/currency";
import "devextreme/localization/globalize/message";
import BaseComponent from "@/components/base/BaseComponent";

import config from "devextreme/core/config";

//데브컴포넌트 전역 등록
import {DxDataGrid, DxColumn, DxEditing, DxSelection, DxFilterRow, DxLookup, DxPager, DxPaging, DxSorting, DxColumnFixing, DxColumnChooser, DxKeyboardNavigation, DxSummary, DxTotalItem, DxStateStoring, DxExport, DxScrolling} from "devextreme-vue/data-grid";
import DxTreeList from "devextreme-vue/tree-list";
import DxTabPanel from "devextreme-vue/tab-panel";

import DxSpeedDialAction from "devextreme-vue/speed-dial-action";
import {DxTextBox, DxButton as DxTextBoxButton} from "devextreme-vue/text-box";
import DxTextArea from "devextreme-vue/text-area";
import DxSelectBox from "devextreme-vue/select-box";
import DxDateBox from "devextreme-vue/date-box";
import DxButton from "devextreme-vue/button";
import {DxBox, DxItem} from "devextreme-vue/box";
import DxCheckBox from "devextreme-vue/check-box";
import DxMultiView from "devextreme-vue/multi-view";
import DxSwitch from "devextreme-vue/switch";
import DxFileUploader from "devextreme-vue/file-uploader";
import DxList from "devextreme-vue/list";
import DxAutocomplete from "devextreme-vue/autocomplete";
import {DxChart, DxSeries} from "devextreme-vue/chart";
import {DxResponsiveBox, DxLocation, DxCol, DxRow} from "devextreme-vue/responsive-box";

import {DxNumberBox, DxButton as DxNumberBoxButton} from "devextreme-vue/number-box";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import "@/assets/lib/css/reset.css";
import "@/assets/lib/css/style.css";
import "@/assets/lib/css/style-temp.css";
import "@/assets/lib/css/component.scss";

import VModal from "vue-js-modal";

Vue.use(VModal, {
  dynamicDefaults: {
    draggable: false,
    resizable: true,
    height: "auto",
  },
  dialog: true,
});

Vue.component("DxList", DxList);
Vue.component("DxDataGrid", DxDataGrid);
Vue.component("DxTreeList", DxTreeList);
Vue.component("DxColumn", DxColumn);
Vue.component("DxEditing", DxEditing);
Vue.component("DxSelection", DxSelection);
Vue.component("DxFilterRow", DxFilterRow);
Vue.component("DxLookup", DxLookup);
Vue.component("DxPager", DxPager);
Vue.component("DxPaging", DxPaging);
Vue.component("DxColumnFixing", DxColumnFixing);
Vue.component("DxSorting", DxSorting);
Vue.component("DxColumnChooser", DxColumnChooser);
Vue.component("DxKeyboardNavigation", DxKeyboardNavigation);
Vue.component("DxSummary", DxSummary);
Vue.component("DxTotalItem", DxTotalItem);
Vue.component("DxStateStoring", DxStateStoring);
Vue.component("DxExport", DxExport);
Vue.component("DxScrolling", DxScrolling);
Vue.component("DxSpeedDialAction", DxSpeedDialAction);
Vue.component("DxFileUploader", DxFileUploader);
Vue.component("DxTabPanel", DxTabPanel);
Vue.component("DxTextBox", DxTextBox);
Vue.component("DxTextBoxButton", DxTextBoxButton);
Vue.component("DxTextArea", DxTextArea);
Vue.component("DxNumberBox", DxNumberBox);
Vue.component("DxNumberBoxButton", DxNumberBoxButton);
Vue.component("DxCheckBox", DxCheckBox);
Vue.component("DxSelectBox", DxSelectBox);
Vue.component("DxDateBox", DxDateBox);
Vue.component("DxButton", DxButton);
Vue.component("DxBox", DxBox);
Vue.component("DxChart", DxChart);
Vue.component("DxSeries", DxSeries);
Vue.component("DxSwitch", DxSwitch);
Vue.component("DxItem", DxItem);
Vue.component("DxMultiView", DxMultiView);
Vue.component("DxResponsiveBox", DxResponsiveBox);
Vue.component("DxLocation", DxLocation);
Vue.component("DxCol", DxCol);
Vue.component("DxRow", DxRow);
Vue.component("DxAutocomplete", DxAutocomplete);

// const originalPush = Router.prototype.push;
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// };

config({
  defaultCurrency: "KOR",
  forceIsoDateParsing: true,
});

Vue.config.productionTip = false;

Vue.prototype.$appInfo = appInfo;

Vue.use(VueSimpleAlert);
Vue.use(UserLib);

var vm = new Vue({
  router,
  //store,
  render: (h) => h(App),
}).$mount("#app");

//export default vm;
